/**
 * Descoberta dos módulos de plugin (docs/plans/plataforma-e-tenants.md §6).
 * Nada aqui conhece um plugin pelo nome: o que estiver linkado em
 * src/modules/<name>/manifest.ts entra; o que não estiver, não existe.
 */
import type { RouteRecordRaw } from 'vue-router'
import type { PluginModuleManifest } from './types'

const discovered = import.meta.glob<{ default: PluginModuleManifest }>('./*/manifest.ts', { eager: true })

export const pluginManifests: PluginModuleManifest[] = Object.entries(discovered)
  .sort(([a], [b]) => a.localeCompare(b))
  .map(([, mod]) => mod.default)
  .filter((m): m is PluginModuleManifest => Boolean(m && m.name && Array.isArray(m.routes)))

export const pluginRoutes: RouteRecordRaw[] = pluginManifests.flatMap((m) => m.routes)
